export const rulesParcelStatus = {
  SUBMITTED: [
    'CANCELLED',
    'CONFLICTED',
    'RETURNING',
    'ASSIGNED',
  ],
  SHIPPED: [],
  DELIVERED: [],
  CANCELLED: ['CANCELLED'],
  ASSIGNED: [
    'CANCELLED',
    'CONFLICTED',
    'RETURNING',
    'SUBMITTED'
  ],
  UNLOADING: [],
  UNLOADED: [],
  REGISTERED: [],
  LOCATED: [],
  CONFLICTED: ['CANCELLED'],
} as any;

export const rulesAdminChangeParcelStatus = {
  RONAD_ADMIN: [
    'SUBMITTED',
    'SHIPPED',
    'DELIVERED',
    'ASSIGNED',
    'UNLOADING',
    'UNLOADED',
    'REGISTERED',
    'LOCATED',
    'CONFLICTED',
    'RETURNING',
    'CANCELLED',
  ],
  MARKETING_MANAGER: [],
  MARKETING_EXPERT: [],
  OPERATIONS_MANAGER: [],
  WAREHOUSE_ADMIN: [
    'ASSIGNED',
    'SUBMITTED',
    'CANCELLED',
    'CONFLICTED',
  ],
  OPERATIONS_EXPERT: [],
  SUPPORT_MANAGER: [],
  AGENCY_ADMIN: [],
  SUPPORT_EXPERT: [],
  LOGISTICS_ADMIN: [],
} as any;
